import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import styles from './sharing_grid_botton.module.css'
import { Modal, ShareButtons } from 'shared'
import { ModalContentProps, SharingGridButtonProps } from './types'

export const SharingGridButton = ({
  shareUrl,
  platforms,
  modalHeader,
  buttonLabel,
  size,
  block,
  variant = 'outline',
  utmMedium,
  utmContent,
  className,
  trackingPageTitle,
  trackingId,
  onClickShareButton,
}: SharingGridButtonProps) => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    setShow(true)
    if (onClickShareButton) onClickShareButton()
  }, [onClickShareButton])

  const onHide = useCallback(() => {
    setShow(false)
  }, [])

  const classes = classNames(
    'btn',
    variant === 'outline' && 'btn-outline-green',
    variant === 'primary' && 'btn-primary',
    size === 'large' && 'btn-large',
    size === 'huge' && 'btn-huge',
    block && 'btn-block',
    className ?? ''
  )

  return (
    <>
      <button onClick={handleClick} className={classes}>
        {buttonLabel}
      </button>

      <Modal
        id="sharing-grid"
        show={show}
        onHide={onHide}
        content={
          <ModalContent
            shareUrl={shareUrl}
            platforms={platforms}
            utmMedium={utmMedium}
            utmContent={utmContent}
            trackingPageTitle={trackingPageTitle}
            trackingId={trackingId}
          />
        }
        header={modalHeader}
      />
    </>
  )
}

const ModalContent = ({
  shareUrl,
  platforms,
  utmMedium,
  utmContent,
  trackingPageTitle,
  trackingId,
}: ModalContentProps): JSX.Element => (
  <>
    <p className={styles.modalDescription}>{i18n.t('projects.show.stats.share_modal_text')}</p>
    <ShareButtons
      project
      platforms={platforms}
      mobileOnly={['whatsapp', 'messenger']}
      shape="roundWithLabel"
      shareUrl={shareUrl}
      withLabel
      asGrid
      utmContent={utmContent}
      utmMedium={utmMedium}
      trackingPageTitle={trackingPageTitle}
      trackingId={trackingId}
      trackingLocation="sharing_modal"
    />
  </>
)
